"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.isInverseStyles = exports.makePatternStyles = exports.Patterns = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var area = ui_blocks_1.INTERACTIVE.area;
var Patterns;

(function (Patterns) {
  Patterns["primary"] = "UTILITY.ACTION";
  Patterns["secondary"] = "UTILITY.ACTION";
  Patterns["simple"] = "GREY.DARK";
})(Patterns = exports.Patterns || (exports.Patterns = {}));

var makePatternStyles = function makePatternStyles(pattern, theme) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern]), theme));
};

exports.makePatternStyles = makePatternStyles;
exports.isInverseStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      color: ", ";\n    }\n  }\n"], ["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"100\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
});
exports.Root = styled_components_1.default.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isInverse', 'pattern'].includes(prop);
  }
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  display: inline-flex;\n  align-items: center;\n  background: transparent;\n  padding: 0;\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      color: ", ";\n    }\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: ", ";\n\n    svg {\n      color: ", ";\n    }\n  }\n\n  ", "\n  ", "\n"], ["\n  ", "\n  display: inline-flex;\n  align-items: center;\n  background: transparent;\n  padding: 0;\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      color: ", ";\n    }\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: ", ";\n\n    svg {\n      color: ", ";\n    }\n  }\n\n  ", "\n  ", "\n"])), area, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.BLUE[\"600\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.BLUE[\"600\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["600"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["600"]', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', exports.makePatternStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', exports.isInverseStyles);
});
var templateObject_1, templateObject_2, templateObject_3;